import { Link } from "react-router-dom";
import { Instagram, Phone, Mail, MapPin } from "lucide-react";
import { BRAND, NAV_LINKS } from "@/lib/brand";

const LINKS = NAV_LINKS;

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-brown text-ivory">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 text-center">
        {/* Logo + name + tagline */}
        <img
          src="/indiabode-logo.jpg"
          alt="IndiAbode logo"
          className="mx-auto h-14 w-14 rounded-full object-cover ring-1 ring-gold/40"
        />
        <h3 className="mt-3 font-serif text-2xl font-semibold">{BRAND.name}</h3>
        <p className="mt-1 text-sm text-ivory/70">{BRAND.footerTagline}</p>

        {/* Instagram */}
        <a
          href={BRAND.instagram}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-instagram"
          aria-label="Instagram"
          className="mt-4 inline-flex h-10 w-10 items-center justify-center rounded-full bg-ivory/10 hover:bg-terracotta transition-colors"
        >
          <Instagram className="h-5 w-5" />
        </a>

        {/* Nav links */}
        <nav className="mt-7 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm">
          {LINKS.map((l) => (
            <Link
              key={l.label}
              to={l.to}
              data-testid={`footer-link-${l.label.toLowerCase()}`}
              className="text-ivory/75 hover:text-ivory transition-colors"
            >
              {l.label}
            </Link>
          ))}
        </nav>

        {/* Contact info */}
        <div className="mt-6 flex flex-col items-center gap-2.5 text-sm">
          <a href={`tel:${BRAND.phoneRaw}`} className="inline-flex items-center gap-2 text-ivory/75 hover:text-ivory transition-colors">
            <Phone className="h-4 w-4 text-gold" /> {BRAND.phone}
          </a>
          <a href={`mailto:${BRAND.email}`} className="inline-flex items-center gap-2 text-ivory/75 hover:text-ivory transition-colors break-all">
            <Mail className="h-4 w-4 text-gold" /> {BRAND.email}
          </a>
          <span className="inline-flex items-center gap-2 text-ivory/60">
            <MapPin className="h-4 w-4 text-gold" /> {BRAND.city}
          </span>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-5 border-t border-ivory/15 text-xs text-ivory/55">
          © {new Date().getFullYear()} IndiAbode · Varanasi
        </div>
      </div>
    </footer>
  );
};

export default Footer;
